import { Button, Checkbox, Col, DatePicker, Flex, Form, Image, Input, InputNumber, Radio, Row, Select, Space, Tabs, Tooltip, Upload } from 'antd';
import { Badge, FloatingLabel } from 'flowbite-react';
import React, { useContext, useEffect, useState } from 'react';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { RxUpdate } from 'react-icons/rx';
import EventEmitter from '../../utils/eventEmitter';
import dayjs from 'dayjs';
import useExpenseAPI from '../apis/expenseAPI';
import StatusComponent from '../../globalComponents/StatusComponent';
import Ribbon from '../../globalComponents/Ribbon';
import AuthContext from '../../utils/AuthContext';
import { MdDelete } from 'react-icons/md';
import { IoMdDocument } from 'react-icons/io';
import SmartButton from '../../globalComponents/SmartButton';
import { CgFileDocument } from "react-icons/cg";


const ExpenseChanges = () => {
  const { expense, expenseCategories, employees, accounts } = useLoaderData();
  const { success, error } = useOutletContext();
  const [form] = Form.useForm();
  const params = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState(expense.description ? expense.description : '');
  const [costCenter, setCostCenter] = useState({});
  const { create, update, submit, uploadDoc } = useExpenseAPI();
  const { user } = useContext(AuthContext);
  const [fileList, setFileList] = useState([]);
  const [previews, setPreviews] = useState(expense.document_urls || []);

  const onChangeName = e => setName(e.target.value);

  const handleSave = () => { 
    let data = form.getFieldsValue();
    data['description'] = name;
    data.expense_date = new Date(data.expense_date);
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    data.user_id = user.id;
    create(data, success);
    // console.log(data);
  };

  const edit = () => { 
    let data = form.getFieldsValue();
    data['description'] = name;
    data.expense_date = new Date(data.expense_date);
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    update(expense.seo, data, success);
  };

  const resetToDraft = () => {
    let data = {};
    data.status = 'to_submit';
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    update(expense.seo, data, success);
  }

  const refuse = () => {
    let data = {};
    data.status = 'refused';
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    update(expense.seo, data, success);
  }

  const submitExpense = () => { 
    let data = form.getFieldsValue();
    data['description'] = name;
    data.expense_date = new Date(data.expense_date);
    data.status = 'submitted';
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    submit(expense.seo, data, success);
  };
  
  const approveExpense = () => { 
    let data = form.getFieldsValue();
    data['description'] = name;
    data.expense_date = new Date(data.expense_date);
    data.status = 'paid';
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    update(expense.seo, data, success);
  };

  const onChangeCostCenter = (V, opt) => {
    setCostCenter(opt);
  };

  useEffect(() => {
    EventEmitter.subscribe('expense', data => {
      navigate('/expense/expenses/'+data);
    });

    return () => {
      EventEmitter.unsubscribe('expense');
    }
  },[])

  useEffect(() => {
    if (costCenter.expense_account_id) {
      form.setFieldValue('expense_account_id', costCenter.expense_account_id);
      form.setFieldValue('total_amount', costCenter.cost_price.$numberDecimal);
    }
  },[costCenter])

  const filter = (input, option) => (
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
  )

  // const submitExpense = () => {
  //   let data = form.getFieldsValue();
  //   data['description'] = name;
  //   data.expense_date = new Date(data.expense_date);
  //   data.cost_center = costCenter.label;
  //   let account = accounts.find(account => account._id === data.expense_account_id);
  //   data.account = `${account?.code} ${account?.name}`;
  //   let employee = employees.find(employee => employee.id === data.employee_id);
  //   data.employee = employee?.name;
  //   if (costCenter.label === undefined) {
  //     let cost_center = expenseCategories.find(cate => cate._id === data.category_id);
  //     data.cost_center = cost_center?.name;
  //   }
  //   delete data.expense_account_id;
  //   delete data.employee_id;
  //   delete data.category_id;
  //   // navigate('/expense/expenses/'+params.action+'/new', {state: data});
  //   // EventEmitter.dispatch('createreportfromexpense', data);
  // }
  // console.log(expense)
  const onChangeFile = async (e) => {
    const formData = new FormData();
    let previews_ = [...previews];
    const image = e.target.files;
    let files = [];
    for (var i = 0; i < image.length; i++) {
      let img = image[i];
      formData.append('image', img);
      let src = img?.url;
      if (!src) {
        src = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(img);
          reader.onloadend = () => resolve(reader.result);
        });
      };
      previews_.push(src);
    };
    if (image.length > 0) {
      formData.append('data', JSON.stringify({seo: expense._id}));
      await uploadDoc(formData, success);
      EventEmitter.dispatch('expense', expense.seo);
    }
    // setPreviews(previews_);
    // setFileList(image);
    // Object.entries(images).forEach(([key, image]) => {
    //   files.push(image)
    //   setFilename((prevState) => [...prevState, image])
    // })
  }
  // console.log(expense)
  return (
    <div className='container mx-auto' style={{ maxWidth: '1400px', height: 'inherit' }}>
      <div className='flex justify-between'>
        <div className='flex'>
          <h3 className='font-bold'>
            <Link to={'/expense/expenses'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Expenses</Link> / {params.action}
          </h3>
          <Tooltip  title='save manually' placement='rightBottom' className='ms-1'>
            <Button onClick={handleSave} type='text' htmlType='button'
              disabled={ expense.seo ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
          {(expense.status !== 'paid' && expense.status) && <Tooltip title='Update' placement='rightBottom' className='ms-1'>
            <Button onClick={edit} disabled={expense.status === 'refused' ? true : false} type='text' htmlType='button'
              // disabled={ formValue.status === 'draft' ? false : true}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<RxUpdate />}
            />
          </Tooltip>}
        </div>
      </div>
      <Row gutter={2}>
        <Col lg={{span: 24}} xl={{span: 16}}>
          <Row>
            <Col md={{span: 24}} lg={{span: 14}}>
              <div className={`flex justify-${expense.status === 'paid' ? 'end' : 'between'} items-center bg-white`}>
                {expense.status !== 'paid' && <Flex gap={2}>
                  {expense.status === 'to_submit' && <Button size='small' type='primary' className='font-semibold bg-[#189aa0] hover-btn ms-1' onClick={submitExpense}>SUBMIT</Button>}
                  {expense.status === 'submitted' && user.access_right.expense_role.name === 'Administrator' &&
                    <Button size='small' type='primary' className='font-semibold bg-[#189aa0] hover-btn ms-1' onClick={approveExpense}>APPROVE</Button>
                  }
                  
                  {expense.status && expense.status !== 'refused' && user.access_right.expense_role.name === 'Administrator' && <Button size='small' type='primary' className='font-semibold bg-[#189aa0] hover-btn ms-1' onClick={refuse}>REFUSE</Button>}
                  {/* <Button size='small' type='text' className='font-semibold text-[#189aa0] ms-1'>ATTACH RECIEPT</Button> */}
                  {expense.status && <div>
                    <label htmlFor='upload'>
                      <span className='font-semibold text-[#189aa0] ms-1 hover:cursor-pointer hover:text-black hover:bg-gray-200 p-1 rounded text-sm'>ATTACH RECEIPT</span>
                    </label>
                    <input id='upload' className='hidden' type='file' onChange={onChangeFile} multiple accept="image/png, image/jpeg"/>
                  </div>}
                  {/* <Upload {...props} listType='text'> ATTAC
                    
                  </Upload> */}
                  {(expense.status && expense.status !== 'refused') && <Button size='small' type='text' className='font-semibold text-[#189aa0] ms-1' onClick={resetToDraft}>RESET TO DRAFT</Button>}
                  
                </Flex>}
              </div>
            </Col>
            <Col md={{span: 24}} lg={{span: 10}}>
              <div className='flex justify-end md:sm-2'>
              <StatusComponent name='EXPENSES' formValue={expense} />
              </div>
            </Col>
          </Row>
          <div className='mt-5 ps-3 pb-3 bg-white shadow'>
            <Flex className={`${expense.seo ? 'flex' : 'hidden'} border-b m-0 `} justify='end'>
              <SmartButton icon={<CgFileDocument size={'1.4rem'}/>} number={previews.length} text={'Documents'} className='border-s-2' to={(user.access_right.expense_role?.name === 'User' && (expense.status !== 'submitted')) ? 'images/'+expense._id : user.access_right.expense_role?.name === 'Administrator' && 'images/'+expense._id}/>
              
            </Flex>
            <div className='relative'>
              {expense.status === 'paid' && <Ribbon text={'PAID'} className={"bg-[#24ad32]"}/>}
            </div>
            <FloatingLabel
              className='text-2xl pt-3'
              variant="standard"
              disabled={
                (expense.status === 'submitted' && user.access_right.expense_role?.name === 'User') ? true :
                ((expense.status === 'paid') && user.access_right.expense_role?.name === 'Administrator') ? true :
                expense.status === 'refused' ? true : !expense.status && false
              }
              placeholder="Description"
              value={name} 
              onChange={onChangeName}
              style={{width: '90%'}}
            />
            <Form 
              form={form}
              labelAlign='left'
              labelCol={{ span: 6 }}
              labelWrap={true}
              initialValues={expense.seo ? {...expense, total_amount: expense.total_amount.$numberDecimal, expense_date: dayjs(expense.expense_date, 'YYYY-MM-DD')} : {expense_date: dayjs(), paid_by: 'company' }}
              disabled={
                (expense.status === 'submitted' && user.access_right.expense_role.name === 'User') ? true :
                ((expense.status === 'paid') && user.access_right.expense_role?.name === 'Administrator') ? true :
                expense.status === 'refused' ? true : !expense.status && false
              }
              autoComplete="off"
              variant='borderless'
            >
              <Row>
                <Col md={{span: 11}}>
                  <Form.Item label='Cost Center' name='category_id' className='font-semibold text-gray-800 mb-1' >
                    <Select options={expenseCategories.map(category => ({value: category._id, label: category.name, expense_account_id: category.expense_account_id, cost_price: category.cost_price}))} onChange={onChangeCostCenter} className='input-outline-none'/>
                  </Form.Item>
                  <Form.Item label='Total' name='total_amount' className='font-semibold text-gray-800 mb-1' >
                    <InputNumber className='w-full font-normal' />
                  </Form.Item>
                  <Form.Item label='Petty Cash' name='is_petty_cash' className='font-semibold text-gray-800 mb-1' valuePropName='checked'>
                    <Checkbox />
                  </Form.Item>
                  <Form.Item label='Paid By' name='paid_by' className='font-semibold text-gray-800 mb-1' >
                    <Radio.Group className='font-normal' disabled={user.access_right.expense_role.name === 'User' ? true : false}>
                      <Space.Compact direction='vertical'>
                        <Radio value='employee'>Employee (to reimburse)</Radio>
                        <Radio value='company'>Company</Radio>
                      </Space.Compact>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col md={{span: 11, offset: 1}}>
                  <Form.Item label='Bill Reference' name='bill_reference' className='font-semibold text-gray-800 mb-1' >
                    <Input type='text' className='input-outline-none w-full font-normal'/>
                  </Form.Item>
                  <Form.Item label='Expense Date' name='expense_date' className='font-semibold text-gray-800 mb-1' >
                    <DatePicker className='input-outline-none w-full font-normal'/>
                  </Form.Item>
                  <Form.Item label='Account' name='expense_account_id' className='font-semibold text-gray-800 mb-1' >
                    <Select showSearch filterOption={filter} options={accounts.map(account => ({value: account._id, label: `${account.code} ${account.name}`}))} className='font-normal' onChange={(v, opt) => form.setFieldValue('employee', opt.label)}/>
                  </Form.Item>
                  <Form.Item label='Employee' name='employee_id' className='font-semibold text-gray-800 mb-1' >
                    <Select options={employees.map(employee => ({value: employee.id, label: employee.name}))} className='font-normal' onChange={(v, opt) => form.setFieldValue('employee', opt.label)} />
                  </Form.Item>
                  <Form.Item label='Manager' name='manager_id' className='font-semibold text-gray-800 mb-1' >
                    <Input disabled className='input-outline-none font-normal' />
                  </Form.Item>
                </Col>
              </Row>
              
            </Form>
          </div>
        </Col>
        <Col className={`${previews.length > 0 ? 'block' : 'hidden'}`} lg={{span: 24}} xl={{span: 8}} >
          <div className='bg-white p-3 shadow' style={{width: '100%',}}>
            <h3 className='text-2xl font-semibold underline' style={{height: '55px'}}>Attachements</h3>
            <div style={{maxHeight: '100%'}}>
              <Row style={{maxHeight: '550px', overflowY: 'scroll'}}>
                {previews.map(file => 
                  <Col span={12}>
                    <Image src={file} style={{height: '300px'}} />
                  </Col>
                )}
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default ExpenseChanges;